import { useAtom, useAtomValue, useSetAtom } from 'jotai';
import { useEffect } from 'react';

import { nowAtom, resolvedThemeAtom, scheduledThemeAtom, themeStateAtom } from './themeAtom';
import type { ThemeKey } from './themeKeys';

const TICK_MS = 60 * 1000;

export interface UseThemeResult {
  resolved: ThemeKey;
  scheduledNow: ThemeKey;
  isAuto: boolean;
  manual: ThemeKey | null;
  setManual: (key: ThemeKey) => void;
  setAuto: () => void;
}

export function useTheme(): UseThemeResult {
  const [state, setState] = useAtom(themeStateAtom);
  const resolved = useAtomValue(resolvedThemeAtom);
  const scheduledNow = useAtomValue(scheduledThemeAtom);
  const setNow = useSetAtom(nowAtom);

  useEffect(() => {
    const id = window.setInterval(() => setNow(new Date()), TICK_MS);
    return () => window.clearInterval(id);
  }, [setNow]);

  useEffect(() => {
    document.documentElement.dataset.theme = resolved;
  }, [resolved]);

  return {
    resolved,
    scheduledNow,
    isAuto: state.auto,
    manual: state.manual,
    setManual: (key: ThemeKey) => setState({ auto: false, manual: key }),
    setAuto: () => setState({ auto: true, manual: null }),
  };
}
